import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { localizeErrorMessage } from '../utils/errorMessages';
import './PasswordChangeModal.css';

const PasswordChangeModal = ({ forced = false, onClose, onSuccess }) => {
  const { updatePassword } = useAuth();
  const [form, setForm] = useState({ currentPassword: '', newPassword: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (form.newPassword !== form.confirmPassword) {
      setError('新密碼與確認密碼不一致');
      return;
    }
    setSaving(true);
    try {
      await updatePassword(form);
      if (onSuccess) onSuccess();
      if (!forced && onClose) onClose();
    } catch (err) {
      setError(localizeErrorMessage(err.message) || '密碼修改失敗');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="password-modal-backdrop" role="dialog" aria-modal="true">
      <form className="password-modal" onSubmit={handleSubmit}>
        <h2>{forced ? '首次登入需修改密碼' : '修改密碼'}</h2>
        <p className="password-modal-desc">
          {forced ? '此帳號由管理員建立，請立即設定新密碼後再繼續使用系統。' : '請輸入目前密碼與新密碼。'}
        </p>
        {error && <div className="alert alert-danger">{error}</div>}
        {!forced && (
          <div className="form-group">
            <label>目前密碼</label>
            <input className="form-control" type="password" name="currentPassword" value={form.currentPassword} onChange={handleChange} disabled={saving} required />
          </div>
        )}
        <div className="form-group">
          <label>新密碼</label>
          <input className="form-control" type="password" name="newPassword" value={form.newPassword} onChange={handleChange} disabled={saving} required minLength={8} />
        </div>
        <div className="form-group">
          <label>確認新密碼</label>
          <input className="form-control" type="password" name="confirmPassword" value={form.confirmPassword} onChange={handleChange} disabled={saving} required minLength={8} />
        </div>
        <div className="password-modal-actions">
          {!forced && <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>取消</button>}
          <button type="submit" className="btn btn-primary" disabled={saving}>{saving ? '更新中...' : '更新密碼'}</button>
        </div>
      </form>
    </div>
  );
};

export default PasswordChangeModal;
